jQuery(document).ready(function($) {
    $('[data-toggler]').click(function(e) {
        e.preventDefault();
        var elm = $(this);
        var toggleElm = $('#'+elm.attr('data-toggler'));
        var state = toggleElm.attr('data-toggler-state');
        if(state == undefined || state == 'off') {
            toggleElm.attr('data-toggler-state','on');
        } else {
            toggleElm.attr('data-toggler-state','off');
        }
    });
});